import { createFileRoute } from '@tanstack/react-router';
import { UserType } from '../../../../types';
import { submissionRouteLoader } from '../../../../utils/submission-route-loader';
import SurveySubmissionWithToken from '../../../../components/pages/survey-submission-with-token';

export const Route = createFileRoute('/$accountSlug/$submissionId/$token/')({
  ...submissionRouteLoader(UserType.INITIAL_USER),
  component: SurveySubmissionWithToken,
});
